import { render, staticRenderFns } from "./NewsAppSettings.vue?vue&type=template&id=6b454e10&scoped=true&"
import script from "./NewsAppSettings.vue?vue&type=script&lang=js&"
export * from "./NewsAppSettings.vue?vue&type=script&lang=js&"
import style0 from "./NewsAppSettings.vue?vue&type=style&index=0&id=6b454e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b454e10",
  null
  
)

export default component.exports